import type { PrimeVuePTOptions } from 'primevue/config';

import { cx } from '@/helpers/cva';

export default {
  root({ instance, props }) {
    return {
      class: cx(
        [`v3-body-regular-400-line-height-auto h-control bordered bg-[--v3-input-field-inputbg] text-[--v3-global-textsecondarycolor] text-black`,
          {
            'outline-none border-[--v3-input-field-inputborder]  focus:border-[--v3-input-field-inputhoverbordercolor] focus:shadow-[0px_0px_0px_2.8px_var(--brand-forestgreenwarm)]': !props?.invalid,
          },
        ],
        instance?.$attrs?.class,
      ),
    };
  },
} satisfies PrimeVuePTOptions['inputtext'];
